/*
|
|               Rebate
_______________________________________________
|
|    This class keep all fields for 
|    new rebate.
|
*/

export class Rebate {
    active                          :boolean = true;
    amount                          :number;
    // client_id         				:number;
    custom                          :boolean = false;
    description                     :string  = '';
    id                              :any     = '';
    name                            :string  = '';
    notes                           :string  = '';
    PDF                             :string  = '';
    // supplier?                       :string  = '';
    supplier_id                     :number;
}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/Rebate.ts